export default __webpack_public_path__ + "assets/sounds/8a3e442061be95acd4689c889a706ebe.mp3";